function isFiniteNumber(value) {
  return Number.isFinite(value);
}

function formatMetric(value, digits = 3) {
  return isFiniteNumber(value) ? value.toFixed(digits) : '--';
}

function classifyMetricLevel(value, thresholds) {
  if (!isFiniteNumber(value)) {
    return 'unknown';
  }

  if (value <= thresholds.low) {
    return 'low';
  }

  if (value >= thresholds.high) {
    return 'high';
  }

  return 'medium';
}

export function analyzeCountyProfile(profile) {
  if (!profile) {
    return {
      summary: '当前未选择具体区县，请选择。',
      reasons: [],
      suggestions: [],
      priority_actions: [],
      metric_snapshot: []
    };
  }

  const ndviLevel = classifyMetricLevel(profile.ndvi_latest, { low: 0.66, high: 0.7 });
  const ecoQualityLevel = classifyMetricLevel(profile.eco_quality, { low: 0.8, high: 0.83 });
  const coordinationLevel = classifyMetricLevel(profile.coordination, { low: 0.65, high: 0.69 });
  const constructionPressureLevel = classifyMetricLevel(profile.construction_area, { low: 60, high: 110 });
  const waterSensitivityLevel = classifyMetricLevel(profile.share_ratio, { low: 4.5, high: 6.2 });

  const reasons = [];
  const suggestions = [];
  const priorityActions = [];

  if (constructionPressureLevel === 'high') {
    reasons.push('建设用地面积处于高位，开发活动压力较大。');
    suggestions.push('优先核查新增建设用地扩张边界，复核建设活动与生态敏感区的叠置关系。');
    priorityActions.push('新增建设用地时序复核');
  } else if (constructionPressureLevel === 'medium') {
    reasons.push('建设用地扩张压力处于中等水平，需要保持持续监测。');
    suggestions.push('维持季度级建设用地变化监测，关注建设边界外扩趋势。');
  }

  if (coordinationLevel === 'low') {
    reasons.push('建设与生态协调度偏低，存在建设活动与生态状态不匹配现象。');
    suggestions.push('对建设与生态冲突区开展重点核查，优先排查低协调度斑块。');
    priorityActions.push('建设与生态冲突区巡查');
  } else if (coordinationLevel === 'medium') {
    reasons.push('建设与生态协调度一般，需要结合年度变化继续跟踪。');
  }

  if (ndviLevel === 'low') {
    reasons.push('NDVI 偏低，植被覆盖与生态恢复状态相对较弱。');
    suggestions.push('对低植被覆盖区域建立修复清单，优先安排现场核验与植被恢复巡查。');
    priorityActions.push('低 NDVI 区域修复核验');
  } else if (ndviLevel === 'high') {
    reasons.push('NDVI 表现较好，区域植被状态整体稳定。');
  }

  if (ecoQualityLevel === 'low') {
    reasons.push('生态质量指标偏弱，局部生态承载能力存在下探风险。');
    suggestions.push('结合生态质量低值区开展动态监测，重点关注生态退化与人为扰动。');
  }

  if (waterSensitivityLevel === 'high') {
    reasons.push('县域水体占比较高，水体周边生态敏感性更强。');
    suggestions.push('加强水体周边缓冲区动态监测，复核异常变化与人为干扰。');
    priorityActions.push('水体敏感区动态复核');
  }

  if (!reasons.length) {
    reasons.push('当前建设、生态与水体指标整体平稳，未发现显著异常。');
    suggestions.push('保持常态化遥感监测与定期现场核验。');
  }

  if (!priorityActions.length) {
    priorityActions.push('常态化遥感监测');
  }

  return {
    summary: reasons[0],
    reasons,
    suggestions: [...new Set(suggestions)],
    priority_actions: [...new Set(priorityActions)],
    metric_snapshot: [
      `NDVI ${profile.ndvi_label || formatMetric(profile.ndvi_latest, 3)}`,
      `生态质量 ${profile.eco_quality_label || formatMetric(profile.eco_quality, 3)}`,
      `协调度 ${profile.coordination_label || formatMetric(profile.coordination, 3)}`,
      `建设用地 ${formatMetric(profile.construction_area, 2)} km²`,
      `水体占比 ${formatMetric(profile.share_ratio, 2)}%`
    ]
  };
}
